module.exports = {"pt-BR":{"components":{"agencyField":{"notifications":{"fetch":{"failure":"Falha ao buscar imobiliárias"}}}}}}